export const NEUTRAL_PLAYER_ID = 'neutral_id'
export const NEUTRAL_PLAYER_COLOR = 'neutral'

export const SPECTATOR_ID = 'spectator_id'
export const SPECTATOR_COLOR = 'spectator'
